import { createUseStyles, Styles } from '../../web-styles'

interface LabelStyles {
  asterisk: Styles
}

export const useStyles = createUseStyles<LabelStyles>((theme) => {
  return {
    asterisk: {
      marginLeft: theme.calcUnit(theme.spacing.s1),
      color: theme.colors.webErrorColor,
    },
  }
})
